/** Phase 2 message files, one per task so parallel builders never share a file (docs/PHASE-2-PLAN.md). */
import { archEnGB } from './arch.js';
import { c2EnGB } from './c2.js';
import { c3EnGB } from './c3.js';
import { x1EnGB } from './x1.js';
import { s10EnGB } from './s10.js';
import { s11EnGB } from './s11.js';
import { s12EnGB } from './s12.js';
import { s13EnGB } from './s13.js';
import { s13bEnGB } from './s13b.js';
import { s14EnGB } from './s14.js';
import { s15EnGB } from './s15.js';
import { s16EnGB } from './s16.js';
import { s17EnGB } from './s17.js';
import { s18EnGB } from './s18.js';
import { s19EnGB } from './s19.js';
import { s20EnGB } from './s20.js';
import { w9EnGB } from './w9.js';
import { w10EnGB } from './w10.js';
import { w11EnGB } from './w11.js';
import { w12EnGB } from './w12.js';
import { w13EnGB } from './w13.js';
import { w14EnGB } from './w14.js';
import { w15EnGB } from './w15.js';
import { m1EnGB } from './m1.js';
import { m2EnGB } from './m2.js';
import { m3EnGB } from './m3.js';
import { k5EnGB } from './k5.js';
import { smtpEnGB } from './smtp.js';
import { appsEnGB } from './apps.js';
export const phase2EnGB = {
    ...archEnGB,
    ...c2EnGB,
    ...c3EnGB,
    ...x1EnGB,
    ...s10EnGB,
    ...s11EnGB,
    ...s12EnGB,
    ...s13EnGB,
    ...s13bEnGB,
    ...s14EnGB,
    ...s15EnGB,
    ...s16EnGB,
    ...s17EnGB,
    ...s18EnGB,
    ...s19EnGB,
    ...s20EnGB,
    ...w9EnGB,
    ...w10EnGB,
    ...w11EnGB,
    ...w12EnGB,
    ...w13EnGB,
    ...w14EnGB,
    ...w15EnGB,
    ...m1EnGB,
    ...m2EnGB,
    ...m3EnGB,
    ...k5EnGB,
    ...smtpEnGB,
    ...appsEnGB,
};
//# sourceMappingURL=index.js.map